/**
 * File download mime types that we support.
 * An entry from here should be passed as the `Accepts` header on download calls.
 */
export enum FILE_MIME_TYPES {
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
